// Disabling this since the props spread should contain `children
// Not adding children explicitly to avoid unintentionally changing the API of this component
// Ideally, children would be marked as required on this component
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { AnchorHTMLAttributes } from 'react';
import { BiProps } from './ComponentProps';
import { useBiClickLogger } from '../hooks/useBiClickLogger';

export interface Props
  extends BiProps,
    AnchorHTMLAttributes<HTMLAnchorElement> {
  innerRef?: (node: HTMLAnchorElement | null) => void;
  children?: React.ReactNode;
}

const BiLink: React.FC<Props> = ({
  biData,
  innerRef,
  stopPropagation,
  ...props
}) => {
  const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);

  if (props.target === '_blank' && !props.rel) {
    props.rel = 'noreferrer';
  }

  return (
    <a
      {...props}
      ref={node => {
        setTrackingRef(node);
        innerRef && innerRef(node);
      }}
    />
  );
};
BiLink.displayName = 'BiLink';

export default BiLink;
